import {
  Component,
  OnInit,
  Optional,
  Host,
  SkipSelf,
  forwardRef,
  Input,
  OnDestroy
} from '@angular/core';
import {
  ControlContainer,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  AbstractControl,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  Validator,
  NG_VALIDATORS
} from '@angular/forms';
import { FormFields } from '../../services/form-fields-generator.service';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { FormAllFieldsValidationService } from '../../services/form-all-fields-validation.service';

@Component({
  selector: 'ab-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AddressComponent),
      multi: true
    }
  ]
})
export class AddressComponent
  implements OnInit, OnDestroy, Validator, ControlValueAccessor {
  @Input() formFields: FormFields;
  @Input() rendering: ComponentRendering;
  @Input() formControlName: string;
  @Input() showSaveAddressCheckbox = false;

  public addressForm = new UntypedFormGroup({
    streetName: new UntypedFormControl(null, [
      Validators.required,
      Validators.maxLength(37)
    ]),
    houseNumber: new UntypedFormControl(null, Validators.maxLength(6)),
    city: new UntypedFormControl(null, [
      Validators.required,
      Validators.maxLength(35)
    ]),
    ZIPCode: new UntypedFormControl(null, Validators.maxLength(10)),
    country: new UntypedFormControl(null, Validators.required)
  });

  public onTouched;

  private formControl: AbstractControl;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer,
    private formAllFieldsValidationService: FormAllFieldsValidationService
  ) {}

  ngOnInit() {
    this.formControl = this.controlContainer.control.get(this.formControlName);
    this.formControl.enable();
    this.formAllFieldsValidationService.addSubForms(this.addressForm);

    if (this.showSaveAddressCheckbox) {
      this.addressForm.addControl(
        'saveBeneficiaryAddress',
        new UntypedFormControl(false)
      );
    }
  }

  ngOnDestroy() {
    if (this.formControl) {
      this.formControl.disable();
      this.formControl.setValue(null);
      this.formControl.clearValidators();
    }
  }

  get streetName() {
    return this.addressForm.get('streetName');
  }

  get city() {
    return this.addressForm.get('city');
  }

  get houseNumber() {
    return this.addressForm.get('houseNumber');
  }

  get ZIPCode() {
    return this.addressForm.get('ZIPCode');
  }

  get country() {
    return this.addressForm.get('country');
  }

  writeValue(value) {
    if (!value) {
      this.addressForm.reset(
        {
          streetName: null,
          houseNumber: null,
          city: null,
          ZIPCode: null,
          country: null
        },
        { emitEvent: false }
      );
    } else {
      this.addressForm.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn) {
    this.addressForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  validate() {
    if (this.addressForm.invalid) {
      return { invalid: true };
    }

    return null;
  }
}
